import { render, staticRenderFns } from "./ProductDetailModal.vue?vue&type=template&id=376969e7&scoped=true&"
import script from "./ProductDetailModal.vue?vue&type=script&lang=js&"
export * from "./ProductDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailModal.vue?vue&type=style&index=0&id=376969e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376969e7",
  null
  
)

export default component.exports